import { MAP_TYPES } from '@deck.gl/carto';

const CUSTOMSQL_FIFTH_SOURCE_ID = 'customSqlFifthSource';

const source = {
  id: CUSTOMSQL_FIFTH_SOURCE_ID,
  type: MAP_TYPES.QUERY,
  connection: undefined,
  data: undefined,
};

export default source;
